import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface EnforcementCasesOverviewProps {
  data: any
}

export default function EnforcementCasesOverview({ data }: EnforcementCasesOverviewProps) {
  const theme = useTheme()
  const cases = data?.exec_case_info ?? []
  const totalCases = cases.length

  const calculateTotalAmount = () => {
    let total = 0
    cases.forEach((item: any) => {
      const caseObj = item?.caseObj || item
      const amount = Number(caseObj?.applicationAmount) || 0
      total += amount
    })
    return total
  }

  const countPendingCases = () => {
    return cases.filter((item: any) => {
      const caseObj = item?.caseObj || item
      const status = caseObj?.caseStatus || ''
      return status !== '' && status !== '已结案' && status !== '结案'
    }).length
  }

  const totalAmount = calculateTotalAmount()
  const pendingCases = countPendingCases()

  const formatAmount = (amount: number) => {
    if (amount === 0) return '¥0'
    if (amount >= 10000) {
      return `¥${(amount / 10000).toFixed(1)}万`
    }
    return `¥${amount.toFixed(0)}`
  }

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            执行案件概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总强制执行案件的整体情况,包括案件数量、执行标的金额及未结案风险。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="案件总数" value={`${totalCases} 件`} subtitle="强制执行案件" />
          <SummaryItem label="涉及执行标的" value={formatAmount(totalAmount)} subtitle="申请执行标的金额" />
          <SummaryItem
            label="未结案数量"
            value={`${pendingCases} 件`}
            subtitle={pendingCases > 0 ? '存在潜在风险' : '无风险敞口'}
          />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
